module.exports = __webpack_public_path__ + "media/images/chancenter01-5496f7f8eef6ca762d28cd7978693091.jpg";